import { Language } from "./components/LanguageContext/types";
import { ApiTranslationKeys, BuildEnv } from "./types";

export const defaultLanguage = {
    languageKey: Language.fi,
    apiKey: ApiTranslationKeys.suomeksi
};

export enum LocalStorageKeys {
    languageSelection = "languageSelection",
    campaignSelection = "campaignSelection"
}

let tApiUrl: string = 'http://localhost:8998/timantti';
let bApiUrl: string = 'http://localhost:8998/booking';
let authUrl: string = 'http://localhost:8998/auth';

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_TOPAASI_API_URL)
        tApiUrl = process.env.REACT_APP_TOPAASI_API_URL;
    if (process.env.REACT_APP_BOOKING_API_URL)
        bApiUrl = process.env.REACT_APP_BOOKING_API_URL;
    if (process.env.REACT_APP_AUTHENTICATION_SERVICE_URL)
        authUrl = process.env.REACT_APP_AUTHENTICATION_SERVICE_URL;
}

let strongAuthAppIdVariable = '';

if (typeof(window) !== 'undefined') {
    switch (window.location.hostname) {
        case 'ajanvaraus.coronaria.fi':
            strongAuthAppIdVariable = 'ac8dba27-f052-421d-a376-caf5bb6c0962'; // prod
            //strongAuthAppIdVariable = 'efe200d3-6932-4569-b637-a65c643ac530'; // test
            break;
        case 'beta.ajanvaraus.coronaria.fi':
            strongAuthAppIdVariable = 'ee059bf5-1091-40a7-a81c-412699767060'; // prod
            //strongAuthAppIdVariable = 'a64b9b97-ca37-41fe-a8e6-c27cc000467b'; // test
            break;
        case 'ajanvaraus.dev.cor.fi':
            //strongAuthAppIdVariable = 'b180969f-4dce-48f2-af1d-2d6ca6ab312c'; // prod
            strongAuthAppIdVariable = '11b4bf5c-4e8b-48ec-a121-d46d935e13e9'; // test
            if (process.env.REACT_APP_TEST_BOOKING_API_URL)
                bApiUrl = process.env.REACT_APP_TEST_BOOKING_API_URL;
            if (process.env.REACT_APP_TEST_AUTHENTICATION_SERVICE_URL)
                authUrl = process.env.REACT_APP_TEST_AUTHENTICATION_SERVICE_URL;
            break;
        case 'staging.docker.dev.cor.fi':
            if (window.location.port !== '8331') {
                console.error('Wrong port for staging client authentication redirect.');
                break;
            }
            //strongAuthAppIdVariable = '80e6af66-0810-4dbb-a3f9-920bc84740c2'; // prod
            strongAuthAppIdVariable = '3e028b44-8f26-480f-af0a-49d1c8cc81d1'; // test
            if (process.env.REACT_APP_TEST_BOOKING_API_URL)
                bApiUrl = process.env.REACT_APP_TEST_BOOKING_API_URL;
            if (process.env.REACT_APP_TEST_AUTHENTICATION_SERVICE_URL)
                authUrl = process.env.REACT_APP_TEST_AUTHENTICATION_SERVICE_URL;
            break;
        case 'localhost':
            if (window.location.port !== '3000') {
                console.log('Wrong port for localhost client authentication redirect.');
                break;
            }
            //strongAuthAppIdVariable = '3b9f9dba-b5db-491c-9cf4-83e9ba8a2f2f'; // prod
            strongAuthAppIdVariable = '627e7775-9134-4587-acc7-b0d67116f2a5'; // test
            break;
        default:
            console.error('No valid hostname detected. Strong auth wont be usable.');
    }
}

export const strongAuthAppId = strongAuthAppIdVariable;
export const bookingApiUrl: string = bApiUrl;
export const timanttiApiUrl: string = tApiUrl;
export const authenticationServiceUrl: string = authUrl;

export const uiSearchTimeoutMs = 100;
export const promiseRejectTimeoutMs = 60000;
export const fireEventsAfterLength = 1;
export const coronariaRootUrl = "https://coronaria.fi";
export const coronariPrivacyPolicyUrl = "/tietosuojaseloste";
export const sheduleAppointmentPhoneNumbersURL = "/";
export const sheduleAppointmentPhoneNumber = "123 456 7890";
export const fiPhonePrefix = "+358";
export const sessionStorageSessionKeyName = "sessionKey";
export const retryConnectionTimes = 3;
export const retryTimeoutMs = 10000;
export const maxCalendarDays = new Date().getDate() + 50;


export const pictureURL = "https://coronaria.fi/wp-content/uploads/topaasi";
export const listOfPricesLink = "/hinnasto";
export const mapBoxStyles = "mapbox://styles/mapbox/streets-v11";
export const mapBoxAPI = "https://api.mapbox.com/geocoding/v5/mapbox.places/";
export const noReplyMail = "noreply@coronaria.fi";

export const BUILD_ENV: BuildEnv = process.env.REACT_APP_BUILD_ENV ?
    process.env.REACT_APP_BUILD_ENV as BuildEnv :
    process.env.NODE_ENV;

export enum PictureSizes {
    "250x250" = "250x250.jpg"
}

export const getDynamicConfig = () => {
    if ( window.location.hostname === "ajanvaraus.coronaria.fi") {
        return {
            expertsTofilterOut:[
                "20158ef4-2ac5-11e9-9d67-0050569b2d10", // A. Ronkanen
                "440ef35f-1cb0-11ef-ae89-005056ba0765", // Timo Testihenkilö
            ]
        };
    }
    return {
        expertsTofilterOut:[]
    };
};

const sleepClinicServicesToFilterOut = [
    "0c7fd187-545e-11e9-a3da-0050569b2d10",
    "15ea0098-545e-11e9-a3da-0050569b2d10",
    "1e97d50d-545e-11e9-a3da-0050569b2d10",
    "26deeb8c-545e-11e9-a3da-0050569b2d10",
    "2d7f7706-545e-11e9-a3da-0050569b2d10",
    "761f2aff-545e-11e9-a3da-0050569b2d10",
    "7c0546ba-545e-11e9-a3da-0050569b2d10",
    "872a778c-545e-11e9-a3da-0050569b2d10",
    "983cd3a2-545e-11e9-a3da-0050569b2d10",
    "a0c4e3bc-545e-11e9-a3da-0050569b2d10",
    "acd8a4f0-545e-11e9-a3da-0050569b2d10",
    "b578d329-545e-11e9-a3da-0050569b2d10",
    "0586d80e-545f-11e9-a3da-0050569b2d10",
    "0e5205c0-545f-11e9-a3da-0050569b2d10",
    "39f75458-545f-11e9-a3da-0050569b2d10",
    "50423e7b-545f-11e9-a3da-0050569b2d10",
    "5eb76109-545f-11e9-a3da-0050569b2d10",
    "65ddc64b-545f-11e9-a3da-0050569b2d10",
    "6c9a4a0b-545f-11e9-a3da-0050569b2d10",
    "bbd053c4-dc76-11ea-b295-8f7bb92fbd2a",
    "00459de2-dc77-11ea-b295-8f7bb92fbd2a",
    "2701c439-dc77-11ea-b295-8f7bb92fbd2a",
    "3004fee9-dc77-11ea-b295-8f7bb92fbd2a",
];

export const servicesToFilterOut = [
    "759d7806-5462-11e9-a3da-0050569b2d10",
    "41b588d2-2ac2-11e9-9d67-0050569b2d10",
    "d778970a-dc77-11ea-b295-8f7bb92fbd2a",
    "4ffef709-0236-11eb-9110-e6fa3002795a",
    "58570c04-0237-11eb-9110-e6fa3002795a", // Physiotherapy services to filter out
    "062c8c97-5460-11e9-a3da-0050569b2d10", // Tähystysklinikka
    "4a32b57c-5460-11e9-a3da-0050569b2d10",
    "742fd424-5460-11e9-a3da-0050569b2d10",
    "79d940af-5460-11e9-a3da-0050569b2d10",
    "89842945-5460-11e9-a3da-0050569b2d10",
    "a4213158-5460-11e9-a3da-0050569b2d10",
    "a9e4c5ae-5460-11e9-a3da-0050569b2d10",
    "b6947bc5-5460-11e9-a3da-0050569b2d10",
    "85e39127-67f3-11e9-b409-0050569b2d10",
    "62ab2b17-90ff-11e9-a1b2-02004c4f4f50",
    "cbabb571-91a4-11e9-a1b2-02004c4f4f50", // Allasterapia
    "62ab2b17-90ff-11e9-a1b2-02004c4f4f50", // Lymphatouch
    "9dc05180-9b18-11ee-aeb5-0050569b2d10", // Fysioterapiaryhmät
    "7b8006cb-9b19-11ee-aeb5-0050569b2d10", // Yksilölliset tukipohjalliset
    "eee58c90-b291-11ed-a6d3-0050569b2d10", // AlterG-juoksumatto
    "f164bd0d-5460-11e9-a3da-0050569b2d10", // End of Physiotherapy services
].concat(sleepClinicServicesToFilterOut);

export const specialitiesToFilterOut = [
    "4020fa0a-6da1-11ea-8c70-02004c4f4f50", // Apuvälinetarpeen arviointi
];

export const customerTypes: { [index: string]: string } = {
    "selfPaying": "itsemaksava",
    "serviceVoucher": "palveluseteli",
    "purchaseService": "ostopalveluvaltuutus",
    "paymentVoucher": "maksusitoumus",
};

export const defaultCustomer = "itsemaksava";
export const optionalDefaultCustomer = "palveluseteli";
export const dentistUuid = "beae4d25-0af8-4dd5-b082-d522e803819b";

export const mobileServiceTooltipCloseTimeoutMs = 5000;

export const popularServices = [
    "361e26e8-5460-11e9-a3da-0050569b2d10", // Fysioterapia
    "775ee75c-d6fb-11ea-b295-8f7bb92fbd2a", // CPAP-hoidon aloitus
    "864f4a9c-6b75-11ef-b712-005056ba0765", // Puheterapian ensikäynti
    "2089a1ff-6b72-11ef-b712-005056ba0765", // Toimintaterapian ensikäynti
];
